import React from "react";
import { Link } from "react-router-dom";
import styles from "./Hero.module.css";
import { usePreloader } from "../../context/PreloaderContext";

// Local asset path
import heroImage from "../../assets/dukamo.jpg";

function Hero() {
  const { setVideoLoaded } = usePreloader();

  const handleImageLoad = () => {
    setVideoLoaded(true);
  };

  return (
    <section className={styles.heroSection}>
      <div className={styles.container}>
        <div className={styles.textContent}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.mainTitle}>DUKAMO COFFEE</h1>
            <h2 className={styles.subTitle}>Coffee Elevated.</h2>
            <p className={styles.description}>
              Experience the rich heritage and passion in every cup. Join us in
              a celebration of our land and community.
            </p>
            <Link to="/products" className={styles.ctaButton}>
              SHOP NOW
            </Link>
          </div>
        </div>

        {/* 💎 The whole container now floats */}
        <div className={styles.floatingContainer}>
          <div className={styles.videoContent}>
            <div className={styles.dynamicShadowWrapper}>
              <img src={heroImage} alt="" className={styles.shadowImage} />
            </div>

            <div className={styles.premiumFrame}>
              <img
                src={heroImage}
                alt="Dukamo Coffee"
                className={styles.fancyHeroImage}
                onLoad={handleImageLoad}
              />
              <div className={styles.frameLabel}>EST. SIDAMA</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
